import { privateInstance } from "../configs";
import { mappers } from "@/mappers";

export const deliverySlipApi = {
  //Slips
  async getDeliverySlips(params) {
    let url = "/inventory/api/deliveryslip/";

    if (params) {
      if (params.store) url += `?store=${params.store}/`;
    }

    const res = await privateInstance.get(url);
    return res.data.map(x => mappers.mapDeliverySlip(x));
  },
  async postDeliverySlip(slip) {
    let url = "/inventory/api/deliveryslip/";
    const res = await privateInstance.post(url, slip);
    return mappers.mapDeliverySlip(res.data);
  },
  async retrieveDeliverySlip(id) {
    let url = `/inventory/api/deliveryslip/${id}/`;
    const res = await privateInstance.get(url);
    return mappers.mapDeliverySlip(res.data);
  },
  async patchDeliverySlip(id, slip) {
    let url = `/inventory/api/deliveryslip/${id}/`;
    const res = await privateInstance.patch(url, slip);
    return mappers.mapDeliverySlip(res.data);
  },
  //Products
  async getDeliverySlipProducts(params) {
    let url = "/inventory/api/deliveryslip/product/";

    if (params) {
      if (params.store) url += `?store=${params.store}/`;
    }

    const res = await privateInstance.get(url);
    return res.data;
  },
  async postDeliverySlipProduct(slip) {
    let url = "/inventory/api/deliveryslip/product/";
    const res = await privateInstance.post(url, slip);
    return res.data;
  },
  async retrieveDeliverySlipProduct(id) {
    let url = `/inventory/api/deliveryslip/product/${id}/`;
    const res = await privateInstance.get(url);
    return res.data;
  },
  async patchDeliverySlipProduct(id, slip) {
    let url = `/inventory/api/deliveryslip/product/${id}/`;
    const res = await privateInstance.patch(url, slip);
    return res.data;
  },
  async deleteDeliverySlipProduct(id) {
    let url = `/inventory/api/deliveryslip/product/${id}/`;
    const res = await privateInstance.delete(url);
    return res.data;
  }
};
